const scrollCheak = (container, buttonLeft, buttonRight) => {
  if (
    !(
      container.firstElementChild == null ||
      container.firstElementChild == 'undefined' ||
      container.firstElementChild == ''
    )
  ) {
    const scrollStart =
      container.scrollLeft - container.firstElementChild.offsetWidth * 0.5
    const scrollEnd =
      container.scrollWidth -
      container.lastElementChild.offsetWidth * 0.5 -
      (container.scrollLeft + container.offsetWidth)
    const disabled = 'disabled'
    if (scrollStart <= 0) {
      buttonLeft.classList.add(disabled)
      buttonRight.classList.remove(disabled)
    } else if (scrollEnd <= 0) {
      buttonRight.classList.add(disabled)
      buttonLeft.classList.remove(disabled)
    } else {
      buttonLeft.classList.remove(disabled)
      buttonRight.classList.remove(disabled)
    }
  }
}

const slideScroll = (element, container, dotContainer = false) => {
  const direction = element.dataset.direction
  const style = window.getComputedStyle(container)
  let gap = parseInt(style.getPropertyValue('--gap'))
  container.classList.add('dragEnd')
  const childWidth = container.querySelector('div').offsetWidth
  let position = Math.round(container.scrollLeft / childWidth)
  const initial = container.scrollLeft
  if (gap == '') {
    gap = 0
  } else {
    gap = parseInt(gap)
  }
  let finalPosition
  if (direction === 'end') {
    finalPosition = position * childWidth + position * gap + (childWidth + gap)
  } else {
    finalPosition = position * childWidth + position * gap - (childWidth + gap)
  }
  
  if( finalPosition > (container.scrollWidth - childWidth) && window.innerWidth > 980 ) {
    container.scrollLeft = 0
    position = 0
  }else if( finalPosition < 0 && window.innerWidth > 980 ) {
    container.scrollLeft = container.scrollWidth
    position = Math.round(container.scrollWidth / childWidth)
  }else {
    container.scrollLeft = finalPosition
  }

  if (dotContainer != false) {
    scrollCheackDot(container, dotContainer, finalPosition)
  }

  var isScrolling
  window.clearTimeout(isScrolling)
  isScrolling = setTimeout(function () {
    container.classList.remove('dragEnd')
  }, 700)
}

const scrollCheackDot = (carrousel, dotContainer, finalPosition) => {
  const width = carrousel.offsetWidth
  const dots = dotContainer.querySelectorAll('.dot')
  let position = Math.round(finalPosition / width)
  
  if (finalPosition < 0) {
    position = 0
  } else if (finalPosition >= width * dots.length) {
    position = dots.length - 1
  }
  
  dotContainer.querySelector('.active').classList.remove('active')
  dots[position].classList.add('active')
}

const moveCarrouselActive = (event, carrousel, dotContainer = false) => {
  let firstPosition = event.touches[0].pageX
  const firstTouch = event.touches[0];                                      
  const xDown = firstTouch.clientX;                                      
  const yDown = firstTouch.clientY; 
  let firstScrollPosition = 0
  let move = 0
  let start = false
  let scroll = false
  const time = event.timeStamp
  
  const handleTouchMove = (event) => {
    let xUp = event.touches[0].clientX;                                    
    let yUp = event.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;
                                                                        
    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
       return true
    } else {
        return false
    }
  };
  
  const _moveCarrousel = (event) => {
    move = firstPosition - event.touches[0].pageX
    firstPosition = event.touches[0].pageX
    
    if( handleTouchMove(event) == true || start == true ) {
      carrousel.scrollLeft += move
      carrousel.classList.add('drag')
      carrousel.classList.add('dragEnd')
      
      if (start == false) {
        start = true
        carrousel.addEventListener('touchend', _leaveCarrousel)
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
      }
    }else {
      document.getElementsByTagName('body')[0].style.overflow = ''
      carrousel.removeEventListener('touchmove', _moveCarrousel, {passive: false})
      return
    }                                                                                         
  }

  const _leaveCarrousel = (event) => {
    document.getElementsByTagName('body')[0].style.overflow = ''
    carrousel.classList.remove('drag')
    
    carrousel.removeEventListener('touchmove', _moveCarrousel, {passive: false})
    carrousel.removeEventListener('touchend', _leaveCarrousel)
    
    const childWidth = carrousel.querySelector('div').offsetWidth
    const position = Math.round(carrousel.scrollLeft / childWidth)
    const style = window.getComputedStyle(carrousel)
    let gap = style.getPropertyValue('--gap')
    if (gap == '') {
      gap = 0
    } else {
      gap = parseInt(gap)
    }
    let finalPosition
    const timeCondition = time + 300 > event.timeStamp
    if (timeCondition && move > 0) {
      finalPosition =
        position * childWidth + position * gap + (childWidth + gap)
    } else if (timeCondition && move < 0) {
      finalPosition =
        position * childWidth + position * gap - (childWidth + gap)
    } else {
      finalPosition = position * childWidth + position * gap
    }
    carrousel.scrollLeft = finalPosition
    start = false
    scroll = false

    if (dotContainer != false) {
      scrollCheackDot(carrousel, dotContainer, finalPosition)
    }

    var isScrolling
    window.clearTimeout(isScrolling)
    isScrolling = setTimeout(function () {
      carrousel.classList.remove('dragEnd')
    }, 700)
  }
  
  carrousel.addEventListener('touchmove', _moveCarrousel, {passive: false})
}

const carrouselScroll = (element, container) => {
  const direction = element.dataset.direction
  let scrollDistance = container.firstElementChild.offsetWidth

  if (direction == 'start') {
    scrollDistance = scrollDistance * -1
  }
  container.scrollLeft += scrollDistance
}

const scrollEvents = (event) => {
  const carrousel = document.querySelectorAll('.slider--container')
  carrousel.forEach((element) => {
    const arrows = element.nextElementSibling.querySelector('.arrows_ui')
    const buttonLeft = arrows.querySelector('.left-arrow')
    const buttonRight = arrows.querySelector('.right-arrow')
    const carrousel = element.querySelector('.slider--box')
    const dotContainer = element.nextElementSibling.querySelector(
      '.dot-container'
    )
    const children = element.querySelectorAll('.slide--row')
    
    scrollCheak(carrousel, buttonLeft, buttonRight)
    carrousel.addEventListener(
      'scroll',
      function () {
        scrollCheak(carrousel, buttonLeft, buttonRight)
      },
    )
    
    buttonLeft.addEventListener(
      'click',
      function () {
        slideScroll(buttonLeft, carrousel, dotContainer)
      },
    )
    buttonRight.addEventListener(
      'click',
      function () {
        slideScroll(buttonRight, carrousel, dotContainer)
      },
    )
    
    window.addEventListener(
      'resize',
      function () {
        carrousel.classList.add('drag')
        const childWidth = carrousel.querySelector('div').offsetWidth
        const position = Math.round(carrousel.scrollLeft / childWidth)
        const style = window.getComputedStyle(carrousel)
        let gap = style.getPropertyValue('--gap')
        if (gap == '') {
          gap = 0
        } else {
          gap = parseInt(gap)
        }
        finalPosition = position * childWidth + position * gap
        carrousel.scrollLeft = finalPosition
        carrousel.classList.remove('drag')
      },
    )

    carrousel.addEventListener(
      'touchstart',
      function (event) {
        moveCarrouselActive(event, carrousel, dotContainer)
      },
      {passive: false}
    )
    
    let i = 0
    children.forEach(() => {
      const dot = document.createElement('span')
      dot.classList.add('dot')
      dotContainer.appendChild(dot)
      dotContainer.querySelectorAll('.dot')[0].classList.add('active')
      let position = i
      dot.addEventListener('click', () => {
        const finalPosition = carrousel.offsetWidth * position
        carrousel.scrollLeft = finalPosition
        scrollCheackDot(carrousel, dotContainer, finalPosition)
      })
      i++
    })
  })
  
  const carrousel_recommend = document.querySelectorAll('.custom_carrousel')
    carrousel_recommend.forEach((element) => {
      const arrows = element.querySelector('.arrows_ui')
      const buttonLeft = arrows.querySelector('.left-arrow')
      const buttonRight = arrows.querySelector('.right-arrow')
      const carrousel = element.querySelector('.custom_carrousel--box')
      
      scrollCheak(carrousel, buttonLeft, buttonRight)
      carrousel.addEventListener(
        'scroll',
        function () {
          scrollCheak(carrousel, buttonLeft, buttonRight)
        },
      )
      
      buttonLeft.addEventListener(
        'click',
        function () {
          slideScroll(buttonLeft, carrousel, false)
        },
      )
      buttonRight.addEventListener(
        'click',
        function () {
          slideScroll(buttonRight, carrousel, false)
        },
      )
    })
}
scrollEvents()

window.onload = () => {
  document.querySelectorAll(".video-media button").forEach(video => {
    video.click()
  });
}


const buynows = document.querySelectorAll('#buynow')
buynows.forEach(buynow => {
  buynow.addEventListener('click', () => {
    document.querySelector('#addToCartButton')
    window.location = '/checkout/'
  })
});

/*
const bundleAction = document.querySelectorAll('#bundleAction')
bundleAction.forEach(button => {
  button.addEventListener('click', () => {
    const variant = document.querySelector('.product-variant-picker-block input:checked');
    //
    const productData = JSON.parse(document.querySelector('#mainProduct').dataset.variant);
    const complementaryData = JSON.parse(document.querySelector('#complementary').dataset.variant);
    let product_id = ''
    let complementary_id = ''
        
    productData.forEach(data => {
      if( data.title == variant.value){
        product_id = data.id
      }
    });
    
    complementaryData.forEach(data => {
      if( data.title == variant.value){
        complementary_id = data.id
      }
    });
    
    let formData = {
      'items': [
        {
        'id': product_id,
        'quantity': 1
       },
       {
        'id': complementary_id,
        'quantity': 1
        }
      ]
     };
     
     addCart(formData)
  })
});


function addCart(formData){
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    data = response.json()
    if( data.status ){
      //sections/drawer-cart.liquid  
      Alpine.store('modals').closeAll()
      Alpine.store('modals').open('cart')
    }
    document.body.dispatchEvent(new CustomEvent("baseline:cart:afteradditem"))
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}*/